function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowM02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 13"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h19v13H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16.223",
  "data-name": "Line 11",
  style: {
    fill: "none",
    stroke: "#434343",
    strokeWidth: "1.3px"
  },
  transform: "translate(1 6.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-8949.46-8528.566 4.681 4.679-4.681 4.68",
  "data-name": "Path 468",
  style: {
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#434343",
    strokeWidth: "1.3px"
  },
  transform: "translate(8962.388 8530.386)"
}));
export default SvgIconArrowM02;